module.exports = __webpack_public_path__ + "static/the-subtle-art-of-not-giving-a-fck-99253fb0f55e67cc5c3d1a054a49d6be.jpg";